module.exports = __webpack_public_path__ + "static/img/6.6291cc2a.png";